var CITY = [{
  text: '北京',
  children: [{
    text: '北京市',
    children: [{
        text: '东城区'
      },
      {
        text: '西城区'
      },
      {
        text: '崇文区'
      },
      {
        text: '宣武区'
      },
      {
        text: '朝阳区'
      },
      {
        text: '丰台区'
      },
      {
        text: '石景山区'
      },
      {
        text: '海淀区'
      },
      {
        text: '门头沟区'
      },
      {
        text: '房山区'
      },
      {
        text: '通州区'
      },
      {
        text: '顺义区'
      },
      {
        text: '昌平区'
      },
      {
        text: '大兴区'
      },
      {
        text: '怀柔区'
      },
      {
        text: '平谷区'
      },
      {
        text: '密云县'
      },
      {
        text: '延庆县'
      }
    ]
  }]
}, 
{
 text:'天津',
 children:[
  {
    text:'天津市',
    children:[
      {
        text:'和平区'
      },
      {
        text:'河东区'
      },
      {
        text:'河西区'
      },
      {
        text:'南开区'
      },
      {
        text: '河北区'
      },
      {
        text:'红桥区'
      },
      {
        text:'塘沽区'
      },
      {
        text:'汉沽区'
      },
      {
        text:'大港区'
      },
      {
        text:'东丽区'
      },
      {
        text:'西青区'
      },
      {
        text: '津南区'
      },
      {
        text:'北辰区'
      },
      {
        text:'武清区'
      },
      {
        text:'宝坻区'
      },
      {
        text:'宁河县'
      },
      {
        text:'静海县'
      },
      {
        text:'蓟县'
      }
    ]
  }
 ]
},
{text: '河北省',
children:[
  {
    text:'石家庄市',
    children:[
      {
        text:'长安区'
      },
      {
        text:'桥东区'
      },
      {
        text:'桥西区'
      },
      {
        text:'新华区'
      },
      {
        text:'井陉矿区'
      },
      {
        text:'裕华区'
      },
      {
        text:'井陉县'
      },
      {
        text:'正定县'
      },
      {
        text:'栾城县'
      },
      {
        text:'行唐县'
      },
      {
        text:'灵寿县'
      },
      {
        text:'高邑县'
      },
      {
        text:'深泽县'
      },
      {
        text:'赞皇县'
      },
      {
        text:'无极县'
      },
      {
        text:'平山县'
      },
      {
        text:'元氏县'
      },
      {
        text: '赵县'
      },
      {
        text:'辛集市'
      },
      {
        text:'藁城市'
      },
      {
        text:'晋州市'
      },
      {
        text:'新乐市'
      },
      {
        text:'鹿泉市'
      }
    ]
  },
  {
    text:'唐山市',
    children:[
      {
        text:'路南区'
      },
      {
        text:'路北区'
      },
      {
        text:'古冶区'
      },
      {
        text:'开平区'
      },
      {
        text:'丰南区'
      },
      {
        text:'丰润区'
      },
      {
        text:'滦县'
      },
      {
        text:'滦南县'
      },
      {
        text:'乐亭县'
      },
      {
        text:'迁西县'
      },
      {
        text:'玉田县'
      },
      {
        text:'唐海县'
      },
      {
        text:'遵化市'
      },
      {
        text:'迁安市'
      }
    ]
  },
  {
    text:'秦皇岛市',
    children:[
      {
        text:'海港区'
      },
      {text:'山海关区'
      },
      {
        text:'北戴河区'
      },
      {
        text:'青龙满族自治县'
      },
      {
        text:'昌黎县'
      },
      {
        text:'抚宁县'
      },
      {
        text:'卢龙县'
      }
    ]
  },
  {
    text:'邯郸市',
    children:[
      {
        text:'邯山区'
      },
      {
        text: '丛台区'
      },
      {
        text:'复兴区'
      },
      {
        text:'峰峰矿区'
      },
      {
        text:'邯郸县'
      },
      {
        text:'临漳县'
      },
      {
        text:'成安县'
      },
      {
        text:'大名县'
      },
      {
        text:'涉县'
      },
      {
        text:'磁县'
      },
      {
        text:'肥乡县'
      },
      {
        text:'永年县'
      },
      {
        text:'邱县'
      },
      {
        text:'鸡泽县'
      },
      {
        text:'广平县'
      },
      {
        text:'馆陶县'
      },
      {
        text:'魏县'
      },
      {
        text:'曲周县'
      },
      {
        text:'武安市'
      }
    ]
  },
  {
    text:'邢台市',
    children:[
      {
        text:'桥东区'
      },
      {
        text:'桥西区'
      },
      {
        text:'邢台县'
      },
      {
        text:'临城县'
      },
      {
        text:'内丘县'
      },
      {
        text:'柏乡县'
      },
      {
        text:'隆尧县'
      },
      {
        text:'任县'
      },
      {
        text:'南和县'
      },
      {
        text:'宁晋县'
      },
      {
        text:'巨鹿县'
      },
      {
        text:'新河县'
      },
      {
        text:'广宗县'
      },
      {
        text:'平乡县'
      },
      {
        text:'威县'
      },
      {
        text:'清河县'
      },
      {
        text:'临西县'
      },
      {
        text:'南宫市'
      },
      {
        text:'沙河市'
      }
    ]
  },
  {
    text:'保定市',
    children:[
      {
        text:'新市区'
      },
      {
        text:'北市区'
      },
      {
        text:'南市区'
      },
      {
        text:'满城县'
      },
      {
        text:'清苑县'
      },
      {
        text:'涞水县'
      },
      {
        text:'阜平县'
      },
      {
        text:'徐水县'
      },
      {
        text:'定兴县'
      },
      {
        text:'唐县'
      },
      {
        text:'高阳县'
      },
      {
        text:'容城县'
      },
      {
        text:'涞源县'
      },
      {
        text:'望都县'
      },
      {
        text:'安新县'
      },
      {
        text:'易县'
      },
      {
        text:'曲阳县'
      },
      {
        text:'蠡县'
      },
      {
        text:'顺平县'
      },
      {
        text:'博野县'
      },
      {
        text:'雄县'
      },
      {
        text:'涿州市'
      },
      {
        text:'定州市'
      },
      {
        text:'安国市'
      },
      {
        text:'高碑店市'
      }
    ]
  },
  {
    text:'张家口市',
    children:[
      {
        text:'桥东区'
      },
      {
        text:'桥西区'
      },
      {
        text:'宣化区'
      },
      {
        text:'下花园区'
      },
      {
        text:'宣化县'
      },
      {
        text:'张北县'
      },
      {
        text:'康保县'
      },
      {
        text:'沽源县'
      },
      {
        text:'尚义县'
      },
      {
        text:'蔚县'
      },
      {
        text:'阳原县'
      },
      {
        text:'怀安县'
      },
      {
        text:'万全县'
      },
      {
        text:'怀来县'
      },
      {
        text:'涿鹿县'
      },
      {
        text:'赤城县'
      },
      {
        text:'崇礼县'
      }
    ]
  },
  {
    text:'承德市',
    children:[
      {
        text:'双桥区'
      },
      {
        text:'双滦区'
      },
      {
        text:'鹰手营子矿区'
      },
      {
        text:'承德县'
      },
      {
        text:'兴隆县'
      },
      {
        text:'平泉县'
      },
      {
        text:'滦平县'
      },
      {
        text:'隆化县'
      },
      {
        text:'丰宁满族自治县'
      },
      {
        text:'宽城满族自治县'
      },
      {
        text:'围场满族蒙古族自治县'
      }
    ]
  },
  {
    text:'沧州市',
    children:[
      {
        text:'新华区'
      },
      {
        text:'运河区'
      },
      {
        text:'沧县'
      },
      {
        text:'青县'
      },
      {
        text:'东光县'
      },
      {
        text:'海兴县'
      },
      {
        text:'盐山县'
      },
      {
        text:'肃宁县'
      },
      {
        text:'南皮县'
      },
      {
        text:'吴桥县'
      },
      {
        text:'献县'
      },
      {
        text:'孟村回族自治县'
      },
      {
        text:'泊头市'
      },
      {
        text:'任丘市'
      },
      {
        text:'黄骅市'
      },
      {
        text:'河间市'
      }
    ]
  },
  {
    text:'廊坊市',
    children:[
      {
        text:'安次区'
      },
      {
        text:'广阳区'
      },
      {
        text:'固安县'
      },
      {
        text:'永清县'
      },
      {
        text:'香河县'
      },
      {
        text:'大城县'
      },
      {
        text:'文安县'
      },
      {
        text:'大厂回族自治县'
      },
      {
        text:'霸州市'
      },
      {
        text:'三河市'
      }
    ]
  },
  {
    text:'衡水市',
    children:[
      {
        text:'桃城区'
      },
      {
        text:'枣强县'
      },
      {
        text:'武邑县'
      },
      {
        text:'武强县'
      },
      {
        text:'饶阳县'
      },
      {
        text:'安平县'
      },
      {
        text:'故城县'
      },
      {
        text:'景县'
      },
      {
        text:'阜城县'
      },
      {
        text:'冀州市'
      },
      {
        text:'深州市'
      }
    ]
  }
]},
{
  text:'山西省',
  children:[
    {
      text:'太原市',
      children:[
        {
          text:'小店区'
        },
        {
          text:'迎泽区'
        },
        {
          text:'杏花岭区'
        },
        {
          text:'尖草坪区'
        },
        {
          text:'万柏林区'
        },
        {
          text:'晋源区'
        },
        {
          text:'清徐县'
        },
        {
          text:'阳曲县'
        },
        {
          text:'娄烦县'
        },
        {
          text:'古交市'
        }
      ]
    },
    {
      text:'大同市',
      children:[
        {
          text:'城区'
        },
        {
          text:'矿区'
        },
        {
          text:'南郊区'
        },
        {
          text:'新荣区'
        },
        {
          text:'阳高县'
        },
        {
          text:'天镇县'
        },
        {
          text:'广灵县'
        },
        {
          text:'灵丘县'
        },
        {
          text:'浑源县'
        },
        {
          text:'左云县'
        },
        {
          text:'大同县'
        }
      ]
    },
    {
      text:'阳泉市',
      children:[
        {
          text:'城区'
        },
        {
          text:'矿区'
        },
        {
          text:'郊区'
        },
        {
          text:'平定县'
        },
        {
          text:'盂县'
        }
      ]
    },
    {
      text:'长治市',
      children:[
        {
          text:'城区'
        },
        {
          text:'郊区'
        },
        {
          text:'长治县'
        },
        {
          text:'襄垣县'
        },
        {
          text:'屯留县'
        },
        {
          text:'平顺县'
        },
        {
          text:'黎城县'
        },
        {
          text:'壶关县'
        },
        {
          text:'长子县'
        },
        {
          text:'武乡县'
        },
        {
          text:'沁县'
        },
        {
          text:'沁源县'
        },
        {
          text:'潞城市'
        }
      ]
    },
    {
      text:'晋城市',
      children:[
        {
          text:'城区'
        },
        {
          text:'沁水县'
        },
        {
          text:'阳城县'
        },
        {
          text:'陵川县'
        },
        {
          text:'泽州县'
        },
        {
          text:'高平市'
        }
      ]
    },
    {
      text:'朔州市',
      children:[
        {
          text:'朔城区'
        },
        {
          text:'平鲁区'
        },
        {
          text:'山阴县'
        },
        {
          text:'应县'
        },
        {
          text:'右玉县'
        },
        {
          text:'怀仁县'
        }
      ]
    },
    {
      text:'晋中市',
      children:[
        {
          text:'榆次区'
        },
        {
          text:'榆社县'
        },
        {
          text:'左权县'
        },
        {
          text:'和顺县'
        },
        {
          text:'昔阳县'
        },
        {
          text:'寿阳县'
        },
        {
          text:'太谷县'
        },
        {
          text:'祁县'
        },
        {
          text:'平遥县'
        },
        {
          text:'灵石县'
        },
        {
          text:'介休市'
        }
      ]
    },
    {
      text:'运城市',
      children:[
        {
          text:'盐湖区'
        },
        {
          text:'临猗县'
        },
        {
          text:'万荣县'
        },
        {
          text:'闻喜县'
        },
        {
          text:'稷山县'
        },
        {
          text:'新绛县'
        },
        {
          text:'绛县'
        },
        {
          text:'垣曲县'
        },
        {
          text:'夏县'
        },
        {
          text:'平陆县'
        },
        {
          text:'芮城县'
        },
        {
          text:'永济市'
        },
        {
          text:'河津市'
        }
      ]
    },
    {
      text:'忻州市',
      children:[
        {
          text:'忻府区'
        },
        {
          text:'定襄县'
        },
        {
          text:'五台县'
        },
        {
          text:'代县'
        },
        {
          text:'繁峙县'
        },
        {
          text:'宁武县'
        },
        {
          text:'静乐县'
        },
        {
          text:'神池县'
        },
        {
          text:'五寨县'
        },
        {
          text:'岢岚县'
        },
        {
          text:'河曲县'
        },
        {
          text:'保德县'
        },
        {
          text:'偏关县'
        },
        {
          text:'原平市'
        }
      ]
    },
    {
      text:'临汾市',
      children:[
        {
          text:'尧都区'
        },
        {
          text:'曲沃县'
        },
        {
          text:'翼城县'
        },
        {
          text:'襄汾县'
        },
        {
          text:'洪洞县'
        },
        {
          text:'古县'
        },
        {
          text:'安泽县'
        },
        {
          text:'浮山县'
        },
        {
          text:'吉县'
        },
        {
          text:'乡宁县'
        },
        {
          text:'大宁县'
        },
        {
          text:'隰县'
        },
        {
          text:'永和县'
        },
        {
          text:'蒲县'
        },
        {
          text:'汾西县'
        },
        {
          text: '侯马市'
        },
        {
          text:'霍州市'
        }
      ]
    },{
      text:'吕梁市',
      children:[
        {
          text:'孝义市'
        },
        {
          text:'离石市'
        },
        {
          text:'汾阳市'
        },
        {
          text:'文水县'
        },
        {
          text:'交城县'
        },
        {
          text:'兴县'
        },
        { text:'临县'
        },
        {
          text:'柳林县'
        },
        {
          text:'石楼县'
        },
        {
          text:'岚县'
        },
        {
          text:'方山县'
        },
        {
          text:'中阳县'
        },
        {
          text:'交口县'
        }
      ]
    }
  ]
},
{
  text:'内蒙古',
  children:[
    {
      text:'呼和浩特市',
      children:[
        {
          text:'新城区'
        },
        {
          text:'回民区'
        },
        {
          text:'玉泉区'
        },
        {
          text:'赛罕区'
        },
        {
          text:'土默特左旗'
        },
        {
          text:'托克托县'
        },
        {
          text:'和林格尔县'
        },
        {
          text:'清水河县'
        },
        {
          text:'武川县'
        }
      ]
    },
    {
      text:'包头市',
      children:[
        {
          text:'东河区'
        },
        {
          text:'昆都仑区'
        },
        {
          text:'青山区'
        },
        {
          text:'石拐区'
        },
        {
          text:'白云矿区'
        },
        {
          text:'九原区'
        },
        {
          text:'土默特右旗'
        },
        {
          text:'固阳县'
        },
        {
          text:'达尔罕茂明安联合旗'
        }
      ]
    },
    {
      text:'乌海市',
      children:[
        {
          text:'海勃湾区'
        },
        {
          text:'海南区'
        },
        {
          text:'乌达区'
        }
      ]
    },
    {
      text:'赤峰市',
      children:[
        {
          text:'红山区'
        },
        {
          text:'元宝山区'
        },
        {
          text:'松山区'
        },
        {
          text:'阿鲁科尔沁旗'
        },
        {
          text:'巴林左旗'
        },
        {
          text:'巴林右旗'
        },
        {
          text:'林西县'
        },
        {
          text:'克什克腾旗'
        },
        {
          text:'翁牛特旗'
        },
        {
          text:'喀喇沁旗'
        },
        {
          text:'宁城县'
        },
        {
          text:'敖汉旗'
        }
      ]
    },
    {
      text:'通辽市',
      children:[
        {
          text:'科尔沁区'
        },
        {text:'科尔沁左翼中旗'
        },
        {
          text:'科尔沁左翼后旗'
        },
        {
          text:'开鲁县'
        },
        {
          text:'库伦旗'
        },
        {
          text:'奈曼旗'
        },
        {
          text:'扎鲁特旗'
        },
        {
          text:'霍林郭勒市'
        }
      ]
    },
    {
      text:'鄂尔多斯市',
      children:[
        {
          text:'东胜区'
        },
        {
          text:'达拉特旗'
        },
        {
          text:'准格尔旗'
        },
        {
          text:'鄂托克前旗'
        },
        {
          text:'鄂托克旗'
        },
        {
          text:'杭锦旗'
        },
        {
          text:'乌审旗'
        },
        {
          text:'伊金霍洛旗'
        }
      ]
    },
    {
      text:'呼伦贝尔市',
      children:[
        {
          text:'海拉尔区'
        },
        {
          text:'阿荣旗'
        },
        {
          text:'莫力达瓦达斡尔族自治旗'
        },
        {
          text:'鄂伦春自治旗'
        },
        {
          text:'鄂温克族自治旗'
        },
        {
          text:'陈巴尔虎旗'
        },
        {
          text:'新巴尔虎左旗'
        },
        {
          text:'新巴尔虎右旗'
        },
        {
          text:'满洲里市'
        },
        {
          text:'牙克石市'
        },
        {
          text:'扎兰屯市'
        },
        {
          text:'额尔古纳市'
        },
        {
          text:'根河市'
        }
      ]
    },
    {
      text:'兴安盟',
      children:[
        {
          text:'乌兰浩特市'
        },
        {
          text:'阿尔山市'
        },
        {
          text:'科尔沁右翼前旗'
        },
        {
          text:'科尔沁右翼中旗'
        },
        {
          text:'扎赉特旗'
        },
        {
          text:'突泉县'
        }
      ]
    },
    {
      text:'锡林郭勒盟',
      children:[
        {
          text:'二连浩特市'
        },
        {
          text:'锡林浩特市'
        },
        {
          text:'阿巴嘎旗'
        },
        {
          text:'苏尼特左旗'
        },
        {
          text:'苏尼特右旗'
        },
        {
          text:'东乌珠穆沁旗'
        },
        {
          text:'西乌珠穆沁旗'
        },
        {
          text:'太仆寺旗'
        },
        {
          text:'镶黄旗'
        },
        {
          text:'正镶白旗'
        },
        {
          text:'正蓝旗'
        },
        {
          text:'多伦县'
        }
      ]
    },
    {
      text:'乌兰察布盟',
      children:[
        {
          text:'集宁市'
        },
        {
          text:'丰镇市'
        },
        {
          text:'卓资县'
        },
        {
          text:'化德县'
        },
        {
          text:'商都县'
        },
        {
          text:'兴和县'
        },
        {
          text:'凉城县'
        },
        {
          text:'察哈尔右翼前旗'
        },
        {
          text:'察哈尔右翼中旗'
        },
        {
          text:'察哈尔右翼后旗'
        },
        {
          text:'四子王旗'
        }
      ]
    },
    {
      text:'巴彦淖尔',
      children:[
        {
          text:'临河市'
        },
        {
          text:'五原县'
        },
        {
          text:'磴口县'
        },
        {
          text:'乌拉特前旗'
        },
        {
          text:'乌拉特中旗'
        },
        {
          text:'乌拉特后旗'
        },
        {
          text:'杭锦后旗'
        }
      ]
    },
    {
      text:'阿拉善盟',
      children:[
        {
          text:'阿拉善左旗'
        },
        {
          text:'阿拉善右旗'
        },
        {
          text:'额济纳旗'
        }
      ]
    }
  ]
},
{
  text:'辽宁省',
  children:[
    {
      text:'沈阳市',
      children:[
        {
          text:'和平区'
        },
        {
          text:'沈河区'
        },
        {
          text:'大东区'
        },
        {
          text:'皇姑区'
        },
        {
          text:'铁西区'
        },
        {
          text:'苏家屯区'
        },
        {
          text:'东陵区'
        },
        {
          text:'新城子区'
        },
        {
          text:'于洪区'
        },
        {
          text:'辽中县'
        },
        {
          text:'康平县'
        },
        {
          text:'法库县'
        },
        {
          text:'新民市'
        }
      ]
    },
    {
      text:'大连市',
      children:[
        {
          text:'中山区'
        },
        {
          text:'西岗区'
        },
        {
          text:'沙河口区'
        },
        {
          text:'甘井子区'
        },
        {
          text:'旅顺口区'
        },
        {
          text:'金州区'
        },
        {
          text:'长海县'
        },
        {
          text:'瓦房店市'
        },
        {
          text:'普兰店市'
        },
        {
          text:'庄河市'
        }
      ]
    },
    {
      text:'鞍山市',
      children:[
        {
          text:'铁东区'
        },
        {
          text:'铁西区'
        },
        {
          text:'立山区'
        },
        {
          text:'千山区'
        },
        {
          text:'台安县'
        },
        {
          text:'岫岩满族自治县'
        },
        {
          text:'海城市'
        }
      ]
    },
    {
      text:'抚顺市',
      children:[
        {
          text:'新抚区'
        },
        {
          text:'东洲区'
        },
        {
          text:'望花区'
        },
        {
          text:'顺城区'
        },
        {
          text:'抚顺县'
        },
        {
          text:'新宾满族自治县'
        },
        {
          text:'清原满族自治县'
        }
      ]
    },
    {
      text:'本溪市',
      children:[
        {
          text:'平山区'
        },
        {
          text:'溪湖区'
        },
        {
          text:'明山区'
        },
        {
          text:'南芬区'
        },
        {
          text:'本溪满族自治县'
        },
        {
          text:'桓仁满族自治县'
        }
      ]
    },
    {
      text:'丹东市',
      children:[
        {
          text:'元宝区'
        },
        {
          text:'振兴区'
        },
        {
          text:'振安区'
        },
        {
          text:'宽甸满族自治县'
        },
        {
          text:'东港市'
        },
        {
          text:'凤城市'
        }
      ]
    },
    {
      text:'锦州市',
      children:[
        {
          text:'古塔区'
        },
        {
          text:'凌河区'
        },
        {
          text:'太和区'
        },
        {
          text:'黑山县'
        },
        {
          text:'义县'
        },
        {
          text:'凌海市'
        },
        {
          text:'北宁市'
        }
      ]
    },
    {
      text:'营口市',
      children:[
        {
          text:'站前区'
        },
        {
          text:'西市区'
        },
        {
          text:'鲅鱼圈区'
        },
        {
          text:'老边区'
        },
        {
          text:'盖州市'
        },
        {
          text:'大石桥市'
        }
      ]
    },
    {
      text:'阜新市',
      children:[
        {
          text:'海州区'
        },
        {
          text:'新邱区'
        },
        {
          text:'太平区'
        },
        {
          text:'清河门区'
        },
        {
          text:'细河区'
        },
        {
          text:'阜新蒙古族自治县'
        },
        {
          text:'彰武县'
        }
      ]
    },
    {
      text:'辽阳市',
      children:[
        {
          text:'白塔区'
        },
        {
          text:'文圣区'
        },
        {
          text:'宏伟区'
        },
        {
          text:'弓长岭区'
        },
        {
          text:'太子河区'
        },
        {
          text:'辽阳县'
        },
        {
          text:'灯塔市'
        }
      ]
    },
    {
      text:'盘锦市',
      children:[
        {
          text:'双台子区'
        },
        {
          text:'兴隆台区'
        },
        {
          text:'大洼县'
        },
        {
          text:'盘山县'
        }
      ]
    },
    {
      text:'铁岭市',
      children:[
        { text:'银州区'
        },
        {
          text:'清河区'
        },
        {
          text:'铁岭县'
        },
        {
          text:'西丰县'
        },
        {
          text:'昌图县'
        },
        {
          text:'调兵山市'
        },
        {
          text:'开原市'
        }
      ]
    },
    {
      text:'朝阳市',
      children:[
        {
          text:'双塔区'
        },
        {
          text:'龙城区'
        },
        {
          text:'朝阳县'
        },
        {
          text:'建平县'
        },
        {
          text:'喀喇沁左翼蒙古族自治县'
        },
        {
          text:'北票市'
        },
        {
          text:'凌源市'
        }
      ]
    },
    {
      text:'葫芦岛市',
      children:[
        {
          text:'连山区'
        },
        {
          text:'龙港区'
        },
        {
          text:'南票区'
        },
        {
          text:'绥中县'
        },
        {
          text:'建昌县'
        },
        {
          text:'兴城市'
        }
      ]
    }
  ]
},
{
  text:'吉林省',
  children:[
    {
      text:'长春市',
      children:[
        {
          text:'南关区'
        },
        {
          text:'宽城区'
        },
        {
          text:'朝阳区'
        },
        {
          text:'二道区'
        },
        {
          text:'绿园区'
        },
        {
          text:'双阳区'
        },
        {
          text:'农安县'
        },
        {
          text:'九台市'
        },
        {
          text:'榆树市'
        },
        {
          text:'德惠市'
        }
      ]
    },
    {
      text:'吉林市',
      children:[
        {
          text:'昌邑区'
        },
        {
          text:'龙潭区'
        },
        {
          text:'船营区'
        },
        {
          text:'丰满区'
        },
        {
          text:'永吉县'
        },
        {
          text:'蛟河市'
        },
        {
          text:'桦甸市'
        },
        {
          text:'舒兰市'
        },
        {
          text:'磐石市'
        }
      ]
    },
    {
      text:'四平市',
      children:[
        {
          text:'铁西区'
        },
        {
          text:'铁东区'
        },
        {
          text:'梨树县'
        },
        {
          text:'伊通满族自治县'
        },
        {
          text:'公主岭市'
        },
        {
          text:'双辽市'
        }
      ]
    },
    {
      text:'辽源市',
      children:[
        {
          text:'龙山区'
        },
        {
          text:'西安区'
        },
        {
          text:'东丰县'
        },
        {
          text:'东辽县'
        }
      ]
    },
    {
      text:'通化市',
      children:[
        {
          text:'东昌区'
        },
        {
          text:'二道江区'
        },
        {
          text:'通化县'
        },
        {
          text:'辉南县'
        },
        {
          text:'柳河县'
        },
        {
          text:'梅河口市'
        },
        {
          text:'集安市'
        }
      ]
    },
    {
      text:'白山市',
      children:[
        {
          text:'八道江区'
        },
        {
          text:'抚松县'
        },
        {
          text:'靖宇县'
        },
        {
          text:'长白朝鲜族自治县'
        },
        {
          text:'江源县'
        },
        {
          text:'临江市'
        }
      ]
    },
    {
      text:'松原市',
      children:[
        {
          text:'宁江区'
        },
        {
          text:'前郭尔罗斯蒙古族自治县'
        },
        {
          text:'长岭县'
        },
        {
          text:'乾安县'
        },
        {
          text:'扶余县'
        }
      ]
    },
    {
      text:'白城市',
      children:[
        {text:'洮北区'
        },
        {
          text:'镇赉县'
        },
        {
          text:'通榆县'
        },
        {
          text:'洮南市'
        },
        {
          text:'大安市'
        }
      ]
    },
    {
      text:'延边朝鲜族自治州',
      children:[
        {
          text:'延吉市'
        },
        {
          text:'图们市'
        },
        {
          text:'敦化市'
        },
        {
          text:'珲春市'
        },
        {
          text:'龙井市'
        },
        {
          text:'和龙市'
        },
        {
          text:'汪清县'
        },
        {
          text:'安图县'
        }
      ]
    }
  ]
},
{
  text:'黑龙江省',
  children:[
    {
      text:'哈尔滨市',
      children:[
        {
          text:'道里区'
        },
        {
          text:'南岗区'
        },
        {
          text:'道外区'
        },
        {
          text:'太平区'
        },
        {
          text:'香坊区'
        },
        {
          text:'动力区'
        },
        {
          text:'平房区'
        },
        {
          text:'呼兰县'
        },
        {
          text:'依兰县'
        },
        {
          text:'方正县'
        },
        {
          text:'宾县'
        },
        {
          text:'巴彦县'
        },
        {
          text:'木兰县'
        },
        {
          text: '通河县'
        },
        {
          text:'延寿县'
        },
        {
          text:'阿城市'
        },
        {
          text:'双城市'
        },
        {
          text:'尚志市'
        },
        {
          text:'五常市'
        }
      ]
    },
    {
      text:'齐齐哈尔市',
      children:[
        {
          text:'龙沙区'
        },
        {
          text:'建华区'
        },
        {
          text:'铁锋区'
        },
        {
          text:'昂昂溪区'
        },
        {
          text:'富拉尔基区'
        },
        {
          text:'碾子山区'
        },
        {
          text:'梅里斯达斡尔族区'
        },
        {
          text:'龙江县'
        },
        {
          text:'依安县'
        },
        {
          text: '泰来县'
        },
        {
          text:'甘南县'
        },
        {
          text:'富裕县'
        },
        {
          text:'克山县'
        },
        {
          text:'克东县'
        },
        {
          text:'拜泉县'
        },
        {
          text:'讷河市'
        }
      ]
    },
    {
      text:'鸡西市',
      children:[
        {
          text:'鸡冠区'
        },
        {
          text:'恒山区'
        },
        {
          text:'滴道区'
        },
        {
          text:'梨树区'
        },
        {
          text:'城子河区'
        },
        {
          text:'麻山区'
        },
        {
          text:'鸡东县'
        },
        {
          text:'虎林市'
        },
        {
          text:'密山市'
        }
      ]
    },
    {
      text:'鹤岗市',
      children:[
        {
          text:'向阳区'
        },
        {
          text:'工农区'
        },
        {
          text:'南山区'
        },
        {
          text:'兴安区'
        },
        {
          text:'东山区'
        },
        {
          text:'兴山区'
        },
        {
          text:'萝北县'
        },
        {
          text:'绥滨县'
        }
      ]
    },
    {
      text:'双鸭山市',
      children:[
        {
          text:'尖山区'
        },
        {
          text:'岭东区'
        },
        {
          text:'四方台区'
        },
        {
          text:'宝山区'
        },
        {
          text:'集贤县'
        },
        {
          text:'友谊县'
        },
        {
          text:'宝清县'
        },
        {
          text:'饶河县'
        }
      ]
    },
    {
      text:'大庆市',
      children:[
        { text:'萨尔图区'
        },
        {
          text:'龙凤区'
        },
        {
          text:'让胡路区'
        },
        {
          text:'红岗区'
        },
        {
          text:'大同区'
        },
        {
          text:'肇州县'
        },
        {
          text:'肇源县'
        },
        {
          text:'林甸县'
        },
        {
          text:'杜尔伯特蒙古族自治县'
        }
      ]
    },
    {
      text:'伊春市',
      children:[
        {
          text:'伊春区'
        },
        {
          text:'南岔区'
        },
        {
          text: '友好区'
        },
        {
          text:'西林区'
        },
        {
          text:'翠峦区'
        },
        {
          text:'新青区'
        },
        {
          text:'美溪区'
        },
        {
          text:'金山屯区'
        },
        {
          text:'五营区'
        },
        {
          text:'乌马河区'
        },
        {
          text:'汤旺河区'
        },
        {
          text:'带岭区'
        },
        {
          text:'乌伊岭区'
        },
        {
          text:'红星区'
        },
        {
          text:'上甘岭区'
        },
        {
          text:'嘉荫县'
        },
        {
          text:'铁力市'
        }
      ]
    },
    {
      text:'佳木斯市',
      children:[
        {
          text:'永红区'
        },
        {
          text:'向阳区'
        },
        {
          text:'前进区'
        },
        {
          text:'东风区'
        },
        {
          text:'郊区'
        },
        {
          text:'桦南县'
        },
        {
          text:'桦川县'
        },
        {
          text:'汤原县'
        },
        {
          text:'抚远县'
        },
        {
          text:'同江市'
        },
        {
          text:'富锦市'
        }
      ]
    },
    {
      text:'七台河市',
      children:[
        {
          text:'新兴区'
        },
        {
          text:'桃山区'
        },
        {
          text:'茄子河区'
        },
        {
          text:'勃利县'
        }
      ]
    },
    {
      text:'牡丹江市',
      children:[
        {
          text:'东安区'
        },
        {
          text:'阳明区'
        },
        {
          text:'爱民区'
        },
        {
          text:'西安区'
        },
        {
          text:'东宁县'
        },
        {
          text: '林口县'
        },
        {
          text:'绥芬河市'
        },
        {
          text:'海林市'
        },
        {
          text:'宁安市'
        },
        {
          text:'穆棱市'
        }
      ]
    },
    {
      text:'黑河市',
      children:[
        {
          text:'爱辉区'
        },
        {
          text:'嫩江县'
        },
        {
          text:'逊克县'
        },
        {
          text:'孙吴县'
        },
        {
          text:'北安市'
        },
        {
          text:'五大连池市'
        }
      ]
    },
    {
      text:'绥化市',
      children:[
        {text:'北林区'
        },
        {
          text:'望奎县'
        },
        {
          text:'兰西县'
        },
        {
          text:'青冈县'
        },
        {
          text:'庆安县'
        },
        {
          text:'明水县'
        },
        {
          text:'绥棱县'
        },
        {
          text:'安达市'
        },
        {
          text:'肇东市'
        },
        {
          text:'海伦市'
        }
      ]
    },
    {
      text:'大兴安岭地区',
      children:[
        {
          text:'呼玛县'
        },
        {
          text:'塔河县'
        },
        {
          text:'漠河县'
        }
      ]
    }
  ]
}
];
module.exports = {
  city: CITY
}



//////////////////
// WEBPACK FOOTER
// ./static/js/area.js
// module id = O+U0
// module chunks = 1